export enum ManualParticipantAddedReason {
  WAS_PRESENT_DID_NOT_SPEAK = 'was_present_did_not_speak',
  SPOKE_BUT_WAS_NOT_CAPTURED = 'spoke_but_was_not_captured',
  WAS_INVITED_BUT_DID_NOT_ATTEND = 'was_invited_but_did_not_attend',
  OTHER = 'other',
}

export interface ManualParticipant {
  userId: string
  name?: string | null
  userType?: string | null
  roles: string[]
  addedByUserId: string
  addedReason: ManualParticipantAddedReason
  addedReasonExplanation?: string | null
  addedReasonConfirmed?: boolean | null
}

export interface ManualParticipantUpsert {
  userId: string
  addedReason: ManualParticipantAddedReason
  addedReasonExplanation?: string
}

export const getManualParticipantReasonLabel = (addedReason: ManualParticipantAddedReason, addedReasonExplanation?: string | null): string => {
  switch (addedReason) {
    case ManualParticipantAddedReason.WAS_PRESENT_DID_NOT_SPEAK:
      return 'Was present but did not speak'
    case ManualParticipantAddedReason.SPOKE_BUT_WAS_NOT_CAPTURED:
      return 'Spoke but was not captured'
    case ManualParticipantAddedReason.WAS_INVITED_BUT_DID_NOT_ATTEND:
      return 'Was invited but did not attend'
    case ManualParticipantAddedReason.OTHER:
      return addedReasonExplanation?.trim() || 'Other'
  }
}
